// extracted by mini-css-extract-plugin
export var chevron = "_jg-2";
export var chevronRotated = "_jg-3";
export var header = "_jg-1";
export var section = "_jg-0";